<script lang="ts" setup>
interface BackgroundAuthProps {
  variant?: "login" | "register";
}

const { variant } = defineProps<BackgroundAuthProps>();
</script>

<template>
  <div class="brand-background" :class="variant" aria-hidden="true">
    <BrandLogo
      mark="icon"
      tone="light"
      class="brand-bolt brand-bolt-panel"
      decorative
    />
    <BrandLogo mark="icon" class="brand-bolt brand-bolt-accent" decorative />
  </div>
</template>

<style lang="scss" scoped>
.brand-background {
  position: fixed;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  background: $gradient;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(
        circle at 18% 20%,
        rgba($primary-light, 0.28),
        transparent 28%
      ),
      radial-gradient(
        circle at 86% 82%,
        rgba($secondary, 0.12),
        transparent 30%
      );
  }

  @media (min-width: $breakpoint-desktop) {
    &.login::after,
    &.register::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 46%;
      background: linear-gradient(145deg, $primary-dark 0%, $primary 100%);
    }

    &.login::after {
      left: 0;
      border-bottom-right-radius: 120px;
    }

    &.register::after {
      right: 0;
      border-bottom-left-radius: 120px;
    }
  }
}

.brand-bolt {
  position: absolute;
}

.brand-bolt-panel {
  z-index: 1;
  top: 8%;
  left: -7%;
  width: clamp(340px, 38vw, 640px);
  opacity: 0.16;
  transform: rotate(-8deg);

  .register & {
    right: -7%;
    left: auto;
    transform: rotate(172deg);
  }
}

.brand-bolt-accent {
  right: -80px;
  bottom: -80px;
  width: clamp(240px, 26vw, 440px);
  opacity: 0.07;
  transform: rotate(12deg);

  .register & {
    right: auto;
    left: -80px;
    transform: rotate(-168deg);
  }
}
</style>
